import { inject } from 'vue'

export function useTracking() {
    const TrackingStore = inject('TrackingStore')
    const tracking = TrackingStore.methods.getTracking()
    return tracking
}
